var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useContext } from "react";
import { withPortal } from "../../hoc/withPortal";
import ActionMenu from "../menu/ActionMenu";
import ActionMenuItem from "./ActionMenuItem";
import ActionMenuHeader from "./ActionMenuHeader";
import Icon from "../icons/Icon";
import { ReverseThemeProvider } from "../../theme/ThemeProvider";
import { ICON_SIZE } from "./ActionMenuItem.style";
import Box from "../box/Box";
import { StyledActionSubMenu } from "./ActionSubMenu.style";
import ActionMenuContext from "./ActionMenuContext";
const ActionSubMenuTitle = (_a) => {
    var { id, onClick, onKeyDown, forwardedRef, label, iconName, isVisible, "data-insights": insightsAttr } = _a, rest = __rest(_a, ["id", "onClick", "onKeyDown", "forwardedRef", "label", "iconName", "isVisible", "data-insights"]);
    return (React.createElement(Box, { ref: forwardedRef },
        React.createElement(ActionMenuItem
        // override onKeyDown from withPortal
        , Object.assign({ 
            // override onKeyDown from withPortal
            onKeyDown: (event) => {
                if (event.key === "ArrowRight") {
                    onClick === null || onClick === void 0 ? void 0 : onClick(event);
                }
                else {
                    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
                }
            }, isSelectable: false, id: id, label: label, iconName: iconName, onClick: onClick, "data-insights": insightsAttr, as: "span", "aria-controls": `${id}_actions`, "aria-expanded": isVisible, extra: React.createElement(ReverseThemeProvider, null,
                React.createElement(Icon, { id: `${id}-next`, "data-insights": insightsAttr && `${insightsAttr}-open`, name: "angleRight", style: { height: "auto", width: `${ICON_SIZE}px` } })) }, rest))));
};
const ActionSubMenuContent = (_a) => {
    var { hide, label, bare = false, children, maxHeight, onSelect, update, "aria-label": ariaLabel, "data-insights": insightsAttr, id } = _a, rest = __rest(_a, ["hide", "label", "bare", "children", "maxHeight", "onSelect", "update", "aria-label", "data-insights", "id"]);
    const menuItems = [
        ...(!bare ? [React.createElement(ActionMenuHeader, { key: "action-menu-header", title: label })] : []),
        ...children,
    ];
    const { onHide } = useContext(ActionMenuContext);
    // when the children change (via quick find for example), it needs to re-position the portal
    useEffect(update, [children]);
    return (React.createElement(StyledActionSubMenu, { onKeyDown: (event) => {
            var _a;
            if (event.key === "Escape") {
                onHide === null || onHide === void 0 ? void 0 : onHide();
            }
            if (event.key === "ArrowLeft") {
                hide(0);
                // return focus to the submenu title
                (_a = document.getElementById(id)) === null || _a === void 0 ? void 0 : _a.focus();
            }
        } },
        React.createElement(ActionMenu, Object.assign({ id: `${id}_actions`, "aria-label": ariaLabel, "data-insights": insightsAttr && `${insightsAttr}_actions`, maxHeight: maxHeight, onSelect: (itemId, event) => {
                if (onSelect) {
                    onSelect(itemId, event);
                }
                hide(0);
                onHide === null || onHide === void 0 ? void 0 : onHide();
            } }, rest), menuItems)));
};
const skidding = -4;
const distance = -8;
const ActionSubMenu = withPortal(ActionSubMenuContent, {
    alignment: "rightTop",
    trigger: "click",
    offset: [skidding, distance],
    returnFocusOnDeactivate: false,
    shouldCloseWhenTargetHidden: true,
    useFocusTrap: false,
    allowTabNavigation: false,
    disablePortal: false,
})(ActionSubMenuTitle);
ActionSubMenu.displayName = "ActionSubMenu";
export default ActionSubMenu;
export const isActionSubMenuProps = (props) => Boolean(props.children);
export const isActionSubMenu = (child) => {
    if (!child || typeof child === "boolean") {
        return false;
    }
    return child.type.displayName === "ActionSubMenu";
};
//# sourceMappingURL=ActionSubMenu.js.map